<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <v-row justify="center">
          <v-snackbar v-model="snackbar" color="success" :timeout="timeout" top>
            {{ alertText }}
            <v-btn dark text @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-row>
        <v-layout row wrap>
          <h1 class="font-weight-bold">{{ web.name }}</h1>
        </v-layout>
      </v-flex>
      <v-divider></v-divider>

      <v-layout row wrap>
        <v-flex xs12 sm9 md9 lg9>
          <v-card dark color="twhite" class="black--text">
            <v-flex>
              <v-img
                :src="web.altImgUrl"
                :srcset="web.imgUrl"
                contain
                aspect-ratio="1.7"
              >
              </v-img>
            </v-flex>
            <v-layout>
              <v-flex ma-2 pa-2>
                <h4 class="font-weight-regular subheading text-md-center">
                  {{ web.description }}
                </h4>
                <v-spacer></v-spacer>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
            <v-row class="d-flex flex-wrap">
              <v-col md="12" class="text-center white">
                <v-toolbar dense rounded color="primary white--text">
                  <v-toolbar-title>What you will get?</v-toolbar-title>
                </v-toolbar>
                <v-list class="text-left twhite">
                  <v-list-item v-for="(dos, i) in ecomDo" :key="i">
                    <v-list-item-title class="black--text">
                      {{ i + 1 }}. {{ dos }}
                    </v-list-item-title>
                    <v-icon color="success">
                      mdi-check
                    </v-icon>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <h3 class="font-weight-bold title">Tags</h3>
            <v-layout row wrap>
              <v-flex>
                <v-chip class="accent">{{ web.tags }}</v-chip>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 md4 lg3>
          <v-card>
            <v-flex ma-0 pa-2>
              <h4 class="font-weight-bold subheading">
                Price:
              </h4>
              <h3
                class="font-weight-bold subheading error--text"
                v-if="$store.state.currency == 'INR'"
              >
                {{ $store.state.currencySymbol }} {{ web.INR }}
              </h3>
              <h3
                class="font-weight-bold subheading error--text"
                v-else-if="$store.state.currency == 'AUD'"
              >
                {{ $store.state.currencySymbol }} {{ web.AUD }}
              </h3>
               <h3
                class="font-weight-bold subheading error--text"
                v-else-if="$store.state.currency == 'PHP'"
              >
                {{ $store.state.currencySymbol }} {{ web.PHP }}
              </h3>
              <h3 class="font-weight-bold subheading error--text" v-else>
                {{ $store.state.currencySymbol }} {{ web.USD }}
              </h3>
            </v-flex>
            <v-flex ma-0 pa-2>
              <h4 class="font-weight-bold subheading">
                Check out the live demo link
              </h4>
              <v-btn
                class="rounded-card"
                block
                color="info"
                target="_blank"
                :href="web.demoUrl"
                >Demo</v-btn
              >
            </v-flex>
            <v-flex ma-0 pa-2 v-if="$store.state.userId != ''">
              <template v-if="isBookMarked">
                <h4 class="font-weight-bold subheading">
                  Seems like you already liked this template
                </h4>
                <v-btn
                  class="rounded-card"
                  block
                  color="success"
                  @click="removeShortList"
                  >Remove from Bookmarks</v-btn
                >
              </template>
              <template v-else>
                <h4 class="font-weight-bold subheading">
                  Shortlist this template
                </h4>
                <v-btn
                  class="rounded-card"
                  block
                  color="success"
                  @click="addShortList"
                  >Add to ShortList</v-btn
                >
              </template>
            </v-flex>
            <v-flex ma-0 pa-2>
              <h4 class="font-weight-bold subheading">
                Select this template for your website and place your order
              </h4>
              <v-btn
                class="rounded-card"
                block
                color="accent"
                :to="{
                  name: 'ecommerceform',
                  params: { web: web }
                }"
                >Place Order</v-btn
              >
            </v-flex>
            <v-flex ma-0 pa-2>
              <h4 class="font-weight-regular subheading">
                Not interested in any of the templates ?
                <a href="/contactus">Contact Us</a> for more.
              </h4>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { functions } from "@/Firebase";

import wooData from "@/woocommerce";

export default {
  name: "EcommerceTemplateDetails",
  data: () => ({
    alertText: "",
    snackbar: false,
    timeout: 25000,
    name: "",
    id: "",
    demoUrl: "",
    description: "",
    features: "",
    web: [],
    temp: [],
    ecomDo: [
      "CUSTOM IMPLEMENTATION OF TEMPLATE",
      "25 PRODUCTS UPLOAD/CONTACT FOR MORE",
      "UNLIMITED CATEGORIES",
      "SEO",
      "PAYMENT GATEWAY INTEGRATION",
      "CDN",
      "OPTIMIZATION",
      "HOSTING",
      "HTTPS/SSL CERTIFICATE",
      "UNIT TESTING",
      "SYSTEM TESTING",
      "ANALYTICS",
      "SITEMAP",
      "CUSTOM EMAIL"
    ],
    isBookMarked: false
  }),
  props: {
    web1: {
      type: Object
    }
  },
  created() {
    if (this.$route.query.wid == null)
      window.location.href = "/explore-ecommerce";
    else {
      if (this.web1 == null) {
        //if web parameter isnt passed fetch from url
        this.wid = this.$route.query.wid;
        this.wname = this.$route.query.wname;
        this.wtechnology = this.$route.query.wtechnology;
      } else {
        this.wid = this.web1.id;
        this.wname = this.web1.name;
        this.wtechnology = this.web1.technology;
      }
      if (this.wid < 1201) this.temp = openData;
      else if (this.wid < 1401) this.temp = prestaData;
      else this.temp = wooData;
      let i = 0;
      //look for id in the json and then save it in web
      for (i = 0; i < this.temp.length; i++) {
        if (this.temp[i].id == this.wid) {
          this.web = this.temp[i];
          break;
        }
      }
      if (this.$store.state.shortListId.includes(this.web.id))
        this.isBookMarked = true;
    }
  },
  methods: {
    addShortList() {
      let card = this.web;
      card.type = "ecommerce";
      let uid = this.$store.state.userId;
      this.$store.commit("addShortList", card);
      this.$store.commit("addShortListId", card.id);
      this.isBookMarked = true;
      var updateShortList = functions.httpsCallable("updateShortList");
      updateShortList({
        uid: uid,
        id: card.id,
        name: card.name,
        tags: card.tags,
        technology: card.technology,
        imgUrl: card.imgUrl,
        type: card.type,
        INR: card.INR,
        USD: card.USD,
        PHP: card.PHP,
        AUD: card.AUD
      })
        .then(docId => {
          this.$store.commit("addShortListDocId", docId.data.id);
          this.alertText = "Added to BookMarks";
          this.snackbar = true;
        })
        .catch(() => {
          alert("error");
        });
    },
    removeShortList() {
      let i = this.$store.state.shortListId.indexOf(this.wid);
      let cid = this.$store.state.shortListDocId[i];
      this.$store.commit("removeShortList", i);
      this.$store.commit("removeShortListId", i);
      this.$store.commit("removeShortListDocId", i);
      this.isBookMarked = false;
      var removeShortList = functions.httpsCallable("removeShortList");
      removeShortList({
        uid: this.$store.state.userId,
        id: cid
      }).then(() => {
        this.alertText = "Removed from BookMarks";
        this.snackbar = true;
      });
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 50px;
}
</style>
